const VALID_HTML_INPUT_TYPES = new Set([
  "text",
  "password",
  "email",
  "number",
  "tel",
  "url",
  "search",
  "date",
  "time",
]);

export default function TextBox({ value, onChange, label, placeholder, type = "text", inputType, disabled, inputId }) {
  const resolvedType = VALID_HTML_INPUT_TYPES.has(inputType) ? inputType : VALID_HTML_INPUT_TYPES.has(type) ? type : "text";
  const normalizedValue =
    resolvedType === "date" && value
      ? (() => {
          const s = String(value).trim();
          if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
          const d = new Date(s);
          if (Number.isNaN(d.getTime())) return "";
          const yyyy = d.getFullYear();
          const mm = String(d.getMonth() + 1).padStart(2, "0");
          const dd = String(d.getDate()).padStart(2, "0");
          return `${yyyy}-${mm}-${dd}`;
        })()
      : value || "";
  return (
    <input
      id={inputId || undefined}
      type={resolvedType}
      className="lfx-input"
      value={normalizedValue}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || label || ""}
      disabled={disabled}
    />
  );
}
